export default __webpack_public_path__ + "static/media/1_0138.a907c596.webp";